<template>
  <el-dialog
    :title="$t('profile.verification-email-dialog.title')"
    :visible="isShown"
    width-size="small"
    height-size="fixed-auto"
    append-to-body
    @close="hideDialog"
  >
    <div class="px-24 py-16">
      <div class="el-text el-text--body-24 mb-16">
        {{ $t('profile.verification-email-dialog.message.paragraph1') }}
      </div>
      <i18n
        class="el-text el-text--body-24 el-text--white-space-pre-line"
        path="profile.verification-email-dialog.message.paragraph2"
      >
        <template #email>
          <strong>{{ originalEmail }}</strong>
        </template>
      </i18n>
    </div>
    <template #footer>
      <el-button
        type="secondary"
        @click="hideDialog"
      >
        {{ $t('action.no') }}
      </el-button>
      <el-button
        type="danger"
        :loading="isVerificationEmailSending || isContactEditing"
        @click="handleSendVerificationEmailClick"
      >
        {{ $t('action.yes') }}
      </el-button>
    </template>
  </el-dialog>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'VerificationEmailDialog',
  props: {
    value: {
      type: Object,
      default: () => ({})
    },
    originalEmail: {
      type: String,
      default: ''
    },
    isShown: {
      type: Boolean,
      default: false
    }
  },
  emits: [
    'hide'
  ],
  computed: {
    ...mapGetters('app', [
      'isVerificationEmailSending',
      'isContactEditing'
    ])
  },
  methods: {
    ...mapActions('app', [
      'sendVerificationEmail',
      'editContact'
    ]),
    async handleSendVerificationEmailClick() {
      const { userId, email, ...formValue } = this.value;

      await Promise.all([
        this.sendVerificationEmail({ userId, email }),
        this.editContact(formValue)
      ]);
      this.hideDialog();
    },
    hideDialog() {
      this.$emit('hide', false);
    }
  }
};
</script>
